/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

import { createRydeColumnHelper, IColumnDef, ITableDto } from "@ryde/shared";

import { useTableDefReportsColumns } from "./use-table-def.reports-columns";

const reportColumnHelper = createRydeColumnHelper<ITableDto>();

interface IUseTableDefsReport {
  tableDefsReports: IColumnDef<ITableDto, unknown>[];
  columnKeys: string[];
}

export const useTableDefsReports = (): IUseTableDefsReport => {
  const { dynamicReportColumns } = useTableDefReportsColumns({
    reportColumnHelper,
  });

  const tableDefsReports: IColumnDef<ITableDto, any>[] = useMemo(() => {
    if (!dynamicReportColumns?.length) {
      return [];
    }

    return [...dynamicReportColumns];
  }, [dynamicReportColumns]);

  const columnKeys = useMemo(
    () => tableDefsReports.filter(x => x.id).map(x => x.id || ""),
    [tableDefsReports],
  );
  return { tableDefsReports, columnKeys };
};
